import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogPresets } from '@principle-theorem/ng-shared';
import { map } from 'rxjs/operators';
import {
  IWaiveDepositDialogData,
  IWaiveDepositDialogResult,
  WaiveDepositDialogComponent,
} from './waive-deposit-dialog.component';

@Injectable()
export class WaiveDepositDialogService {
  constructor(private _dialog: MatDialog) {}

  async open(
    data?: IWaiveDepositDialogData
  ): Promise<IWaiveDepositDialogResult | undefined> {
    return this._dialog
      .open<
        WaiveDepositDialogComponent,
        IWaiveDepositDialogData,
        IWaiveDepositDialogResult | undefined
      >(
        WaiveDepositDialogComponent,
        DialogPresets.medium({ data, autoFocus: true })
      )
      .afterClosed()
      .pipe(map((response) => response || undefined))
      .toPromise();
  }
}
